import type { UIEvent } from './events';

export interface UIButtonEventBinding {
  id: string;
  event: UIEvent;
}

export const ACTION_BUTTON_BINDINGS = [
  { id: 'undoBtn', event: { type: 'undo' } },
  { id: 'skipShipBtn', event: { type: 'skipShip' } },
  { id: 'confirmBtn', event: { type: 'confirm' } },
  { id: 'landFromOrbitBtn', event: { type: 'landFromOrbit' } },
  { id: 'selectFleetBtn', event: { type: 'selectFleet' } },
  {
    id: 'launchMineBtn',
    event: { type: 'launchOrdnance', ordType: 'mine' },
  },
  {
    id: 'launchTorpedoBtn',
    event: { type: 'launchOrdnance', ordType: 'torpedo' },
  },
  {
    id: 'launchNukeBtn',
    event: { type: 'launchOrdnance', ordType: 'nuke' },
  },
  { id: 'emplaceBaseBtn', event: { type: 'emplaceBase' } },
  { id: 'nextOrdnanceBtn', event: { type: 'skipOrdnanceShip' } },
  { id: 'confirmOrdnanceBtn', event: { type: 'confirmOrdnance' } },
  { id: 'attackBtn', event: { type: 'attack' } },
  { id: 'fireBtn', event: { type: 'skipCombat' } },
  { id: 'skipCombatBtn', event: { type: 'skipCombat' } },
  { id: 'skipLogisticsBtn', event: { type: 'skipLogistics' } },
  { id: 'confirmTransfersBtn', event: { type: 'confirmTransfers' } },
] as const satisfies readonly UIButtonEventBinding[];

export const STATIC_BUTTON_BINDINGS = [
  ...ACTION_BUTTON_BINDINGS,
  {
    id: 'nextMissionBtn',
    event: {
      type: 'startSinglePlayer',
      scenario: 'duel',
      difficulty: 'easy',
    },
  },
  { id: 'rematchBtn', event: { type: 'rematch' } },
  { id: 'replayMatchPrevBtn', event: { type: 'replayMatchPrev' } },
  { id: 'replayMatchNextBtn', event: { type: 'replayMatchNext' } },
  { id: 'replayToggleBtn', event: { type: 'toggleReplay' } },
  { id: 'replayStartBtn', event: { type: 'replayStart' } },
  { id: 'replayPrevBtn', event: { type: 'replayPrev' } },
  { id: 'replayNextBtn', event: { type: 'replayNext' } },
  { id: 'replayEndBtn', event: { type: 'replayEnd' } },
  { id: 'replayBarStartBtn', event: { type: 'replayStart' } },
  { id: 'replayBarPrevBtn', event: { type: 'replayPrev' } },
  { id: 'replayBarPlayBtn', event: { type: 'replayPlayPause' } },
  { id: 'replayBarNextBtn', event: { type: 'replayNext' } },
  { id: 'replayBarEndBtn', event: { type: 'replayEnd' } },
  { id: 'replayBarSpeedBtn', event: { type: 'replayCycleSpeed' } },
  { id: 'exitBtn', event: { type: 'exit' } },
  // Floating in-game exit (visible only in `hud` mode via buildScreenVisibility).
  // Shares the same `exit` event as the game-over Exit button.
  { id: 'exitGameBtn', event: { type: 'exit' } },
] as const satisfies readonly UIButtonEventBinding[];

export const ACTION_BUTTON_IDS = ACTION_BUTTON_BINDINGS.map(({ id }) => id);
